import { render } from "./ModalOpenSupport.vue?vue&type=template&id=3ab3b156&scoped=true&ts=true"
import script from "./ModalOpenSupport.vue?vue&type=script&lang=ts"
export * from "./ModalOpenSupport.vue?vue&type=script&lang=ts"

import "./ModalOpenSupport.vue?vue&type=style&index=0&id=3ab3b156&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ab3b156"]])

export default __exports__